<template>
    <div>
        <div style="margin-bottom: 2rem;">
            <el-button @click="openBind">
                <p style="color: #334681;">绑定试卷</p>
            </el-button>
        </div>
        <Table
                :totalSize="pages.total"
                :pagination="false"
                :sequenceNumber="false"
                :operationWidth="350"
                :currentPage="pages.current"
                :pageSize="pages.size"
                navHeight=40
                ref="table"
                :tableData="tableData"
                :tableKey="tableKey"
            >
            <template slot="operation" slot-scope="data">
                <el-tooltip class="item" effect="dark" content="解除绑定" placement="top-start">
                    <i class="iconfont icon-jiechubangding" @click="unBind(data.data.row)"></i>
                </el-tooltip> 
            </template>
        </Table>
        <bind-paper :hasCheckedList="tableData" @bind_success="pageCourseTestPaperList" ref="bind_paper"></bind-paper>
    </div>
</template>

<script>
import { PageCourseTestPaperList,BindOrUnbindCourse } from '@/api/paper';
import BindPaper from '../paperMag/BindPaper.vue';
    export default {
  components: { BindPaper },
        data(){
            return {
                pages:{
                    current:1,
                    size:10,
                    keywords:'',
                    total:0
                },
                tableData:[],
                tableKey:[
                {name: '试卷名称', value: 'testPaperName'},
                {name: '所属分类', value: 'classifyName'},
                {name: '创建时间', value: 'createTime',},
                {name: '题目数', value: 'questionCount'},
                {name: '操作', value: 'operation',slot:'operation'},
                ]
            }
        },
        computed:{
            courseId(){
                return this.$store.state.course.currentCourseId||this.$route.query.id||'';
            }
        },
        methods:{
            /**分页查询课程已绑定试卷 */
            pageCourseTestPaperList(){
                var params={
                "bindType": 1,
                "courseId": this.courseId,
                "current": this.pages.current,
                "size": this.pages.size
                }
                PageCourseTestPaperList(params).then(res=>{
                    if(res.code==200){
                        this.tableData=res.data.records;
                    }
                })
            },
            /**打开绑定试卷弹窗 */
            openBind(){
                var dialog=this.$refs.bind_paper;
                if(dialog){
                    dialog.dialogVisible=true;
                    dialog.search();
                }
            },
            /**解除绑定 */
            unBind(item){
                var params={
                "bindType": 0,
                "courseIds": [this.courseId],
                "testPaperIds": [item.id]
                };
                BindOrUnbindCourse(params).then(res=>{
                    if(res.code==200){
                        this.$msg({
                        showClose: true,
                        message: "解除绑定成功",
                        type: "success",
                    });
                    this.pageCourseTestPaperList();
                    }
                })
            },
        },
    }
</script>

<style lang="less" scoped>
.icon-jiechubangding{
    color: var(--red);
    font-size: 1.8rem;
    cursor: pointer;
}
</style>